module.exports = __webpack_public_path__ + "static/media/Euronics_logotype_2col_wht_rgb.023e4351.svg";